export const humanTimeZone = (timeZone, locale) => {
    return Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZoneName: "shortGeneric",
        timeZone: timeZone
    }).formatToParts(new Date(0)).filter(part => part.type === 'timeZoneName').map(part => part.value)[0];
};
